import type React from "react";

import { faStars } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useGetClinicPartnerAvgNps } from "api/services/clinic_partner/hooks";
import { NoGraphData } from "routes/admin/components/NoGraphData";
import { SkeletonLayout } from "shared/atoms/SkeletonLayout";
import { WidgetBox } from "shared/containers/WidgetBox";
import { BLUE } from "theme/colors";

export const ClinicPartnerAvgNps: React.FC = () => {
  const { t } = useTranslation();
  const { data: npsData, isLoading } = useGetClinicPartnerAvgNps();

  const data = npsData?.avg_nps;
  const hasData = data !== undefined && data !== null;

  return (
    <WidgetBox
      title={t("partner_admin.avg_nps.title")}
      description={t("partner_admin.avg_nps.description")}
      icon={<FontAwesomeIcon icon={faStars} />}
      skipPadding
    >
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "240px" }}>
        {isLoading && <SkeletonLayout layout={{ type: "skeleton", variant: "text", typographyVariant: "h2" }} />}
        {!isLoading && !hasData && <NoGraphData title={t("patients.graph.no_data")} />}
        {!isLoading && hasData && (
          <Typography variant="h1" fontSize="80px" color={BLUE[100]}>
            {data}
          </Typography>
        )}
      </Box>
    </WidgetBox>
  );
};
